import { AxiosResponse } from 'axios';

import axios from 'utils/axios';

import { getAccountId } from './auth';

export type EmailTemplate = {
  id: string;
  name: string;
  subject: string;
  body: string;
};

export type GetEmailTemplatesResponse = EmailTemplate[];

type DeleteEmailTemplatesResponse = {
  status: string;
};

export const getEmailTemplates = async () => {
  const response = (await axios.get(
    `/acc/${getAccountId()}/email_templates`,
  )) as AxiosResponse<GetEmailTemplatesResponse>;

  return response.data;
};

export const createEmailTemplate = async (template: Omit<EmailTemplate, 'id'>) => {
  const response = (await axios.post(`/acc/${getAccountId()}/email_templates`, {
    ...template,
  })) as AxiosResponse<EmailTemplate>;

  return response.data;
};

export const updateEmailTemplate = async (template: EmailTemplate) => {
  const response = (await axios.patch(`/acc/${getAccountId()}/email_templates/${template.id}`, {
    ...template,
  })) as AxiosResponse<EmailTemplate>;

  return response.data;
};

export const deleteEmailTemplate = async (id: string) => {
  const response = (await axios.delete(
    `/acc/${getAccountId()}/email_templates/${id}`,
  )) as AxiosResponse<DeleteEmailTemplatesResponse>;

  return response.data;
};
